/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { formatServerDate, parseDisplayDate } from '@/util/MomentUtils';
import cleanUpResponse from '@/util/cleanUpResponse';

export default async function UpdateAWPackageFDRInfo(formData) {
  const response = await $.soap({
    body: {
      UpdateAWPackageFDRInfo: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackageFDR: {
          AWPackageID: formData.awPackageId,
          VendorCode: formData.vendorCode,
          FundingCategoryID: formData.fundingCategoryId,
          KOName: formData.koName,
          KOPGr: formData.pgr,
          KOPOCFirstName: formData.pocFirstName,
          KOPOCLastName: formData.pocLastName,
          KOPOCEmail: formData.pocEmail,
          KOPOCPhone: formData.pocPhone,
          KOPOCFax: formData.pocFax,
          PGCCode: formData.pgcCode
        },
        Address: {
          Address1: formData.address.address1,
          BuildingFloorNumber: formData.address.buildingFloorNumber,
          RoomPoleNumber: formData.address.roomPoleNumber,
          City: formData.address.city,
          Zip: formData.address.zip,
          RegionID: formData.address.regionId
        },
        AWPackage: {
          ID: formData.awPackageId,
          ContractStartDate: formatServerDate(parseDisplayDate(formData.contractStartDate)),
          ContractEndDate: formatServerDate(parseDisplayDate(formData.contractEndDate)),
          Vendor: formData.vendor
        }
      }
    }
  });
  cleanUpResponse(response);
  return response;
}
